import { useState } from 'react';
import { toast } from 'react-hot-toast';
import DialogShell from '../../components/DialogShell';
import UserSearchSelect from '../../components/UserSearchSelect';
import { createSubscription } from '../../services';

const SERVICE_OPTIONS = ['fb_graph', 'fb_action', 'tiktok'];

function getErrorMessage(error) {
  return error.response?.data?.error || error.response?.data?.message || error.message || 'Request failed';
}

export default function CreateSubscriptionDialog({ onClose, onCreated }) {
  const [selectedUser, setSelectedUser] = useState([]);
  const [serviceCallback, setServiceCallback] = useState(SERVICE_OPTIONS[0]);
  const [requestsLimit, setRequestsLimit] = useState(1000);
  const [concurrency, setConcurrency] = useState(5);
  const [durationDays, setDurationDays] = useState(31);
  const [boughtPrice, setBoughtPrice] = useState(0);
  const [note, setNote] = useState('');
  const [isFreemium, setIsFreemium] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();

    if (!selectedUser.length) {
      toast.error('Vui lòng chọn user.');
      return;
    }

    setIsSubmitting(true);
    try {
      const created = await createSubscription({
        user_id: selectedUser[0].id,
        service_callback: serviceCallback,
        requests_limit: Number(requestsLimit),
        concurrency: Number(concurrency),
        duration_days: Number(durationDays),
        bought_price: Number(boughtPrice),
        note: note || null,
        is_freemium: isFreemium,
      });
      toast.success('Đã tạo subscription mới.');
      onCreated(created);
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <DialogShell onClose={onClose}>
      <h4 className="text-lg font-semibold text-slate-900">Tạo subscription mới</h4>
      <form className="mt-4 space-y-3" onSubmit={handleSubmit}>
        <div>
          <label className="text-xs text-slate-500">User</label>
          <UserSearchSelect value={selectedUser} onChange={setSelectedUser} multiple={false} />
        </div>

        <div>
          <label className="text-xs text-slate-500">Service</label>
          <select
            value={serviceCallback}
            onChange={(event) => setServiceCallback(event.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
          >
            {SERVICE_OPTIONS.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs text-slate-500">Requests limit</label>
            <input
              type="number"
              value={requestsLimit}
              onChange={(event) => setRequestsLimit(event.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
            />
          </div>
          <div>
            <label className="text-xs text-slate-500">Concurrency</label>
            <input
              type="number"
              value={concurrency}
              onChange={(event) => setConcurrency(event.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
            />
          </div>
          <div>
            <label className="text-xs text-slate-500">Duration (ngày)</label>
            <input
              type="number"
              value={durationDays}
              onChange={(event) => setDurationDays(event.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
            />
          </div>
          <div>
            <label className="text-xs text-slate-500">Giá (USD)</label>
            <input
              type="number"
              step="0.01"
              value={boughtPrice}
              onChange={(event) => setBoughtPrice(event.target.value)}
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
            />
          </div>
        </div>

        <div>
          <label className="text-xs text-slate-500">Ghi chú</label>
          <input
            value={note}
            onChange={(event) => setNote(event.target.value)}
            className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-cyan-400"
          />
        </div>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input type="checkbox" checked={isFreemium} onChange={(event) => setIsFreemium(event.target.checked)} />
          Freemium
        </label>

        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded-lg border border-slate-200 px-4 py-2 text-sm text-slate-700">
            Hủy
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className="rounded-lg bg-cyan-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-60"
          >
            {isSubmitting ? 'Đang tạo...' : 'Tạo subscription'}
          </button>
        </div>
      </form>
    </DialogShell>
  );
}
